/* eslint-disable */
import { GETDASHBOARSDUSERLIST, GETATTENDENTLISTDATA, GETADVERTISEMENTANDEXAMLIST, GETVENUEDASHBOARDCOUNT, GETDOCUMENTLISTDATA, GETALLEXAMLISTDATA, DOWNLOADCIRCULARDATA, GET_All_DEBARRED_PAGINATION, GET_DEBARRED_BY_ID, GET_DEBARRED_PAGINATION, ADD_NEW_DEBARRED, UPDATE_DEBARRED, DELETE_DEBARRED_DATA, GET_VENUE_LIST, GET_DEBARRED_DROPDOWN, GET_EVIDENCE_DATA, GETROLES, GET_ALL_COLLECTOR_VENUES, GET_ATTENDANCE_PAGINATION_VENUE, GET_ADVERTISEMENT_DETAILS_BY_VENUE, GET_EXAMLIST_PAGINATION_VENUE, GET_USERLIST_PAGINATION_VENUE, GET_VENUECOLLECTOR_COUNT, GET_VENUE_ADVERTISEMENT_LIST, GET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import { SET_GET_ALL_DASHBOARDS_USER_LIST, SET_USERS_LIST_PAGE_NO_COUNTER, SET_GET_ALL_ATTENDENT_LIST, SET_ATTENDENT_LIST_PAGE_NO_COUNTER, SET_EXAM_PAGE_NO_COUNTER, SET_ALL_EXAM_LIST, SET_EXAM_DETAILS, SET_GET_ADVERTISEMENT_AND_EXAM_LIST, SET_GET_VENUE_DASHBOARD_COUNT, SET_GET_ALL_DOCUMENT_LIST, SET_DOCUMENT_LIST_PAGE_NO_COUNTER, SET_ALL_DEBARRED_DATA, SET_DEBARRED_DATA, SET_ALL_DEBARRED_PAGE_NO_COUNTER, SET_ALL_VENUES_LIST, SET_ALL_DEBARRED_DROPDOWN, SET_EVIDENCE_DATA, GET_ALL_ROLES, UPDATE_ATTENDENT_LIST, UPDATE_ATTENDENT_LIST_PAGE_NO_COUNTER, GET_ALL_COLLECTOR_VENUE, GET_COLLECTOR_ATTENDANCE_LIST, SET_COLLECTOR_ATTENDANCE_LIST, UPDATE_ATTENDENT_LIST_COLLECTOR_PAGINATION, UPDATE_ATTENDENT_LIST_COLLECTOR, SET_EXAM_PAGE_NO_COUNTER_COLLECTOR, SET_ALL_EXAM_LIST_COLLECTOR, SET_USERS_LIST_PAGE_NO_COUNTER_COLLECTOR, SET_GET_ALL_COLLECTOR_USER_LIST, SET_GET_COLLECTOR_DASHBOARD_COUNT, SET_VENUE_ADVERTISEMENT_LIST, SET_VENUE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER, SET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST, SET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER} from '../../common/constants/ActionTypes';
import {  toastr } from 'react-redux-toastr';
import moment from 'moment';
import axios from "axios";
import FileDownload from "js-file-download";

export const getAdvertisementAndExamList = (year) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETADVERTISEMENTANDEXAMLIST, {
                headers: { Authorization: `Bearer ${token}` },
                params: { "year": year}
            });
            dispatch({
                type: SET_GET_ADVERTISEMENT_AND_EXAM_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getAdvertisementAndExamListByVenue = (venueid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ADVERTISEMENT_DETAILS_BY_VENUE + `/${venueid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_ADVERTISEMENT_AND_EXAM_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getDashboardsUserListData = (pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETDASHBOARSDUSERLIST + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response) {
                dispatch({
                    type: SET_GET_ALL_DASHBOARDS_USER_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_USERS_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_DASHBOARDS_USER_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAttendentListData = (examId, pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETATTENDENTLISTDATA + `/${examId}` + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response) {
                dispatch({
                    type: SET_GET_ALL_ATTENDENT_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ATTENDENT_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

                // if (requestBody.length > 0) {
                //     let successMessage = "Data Updated successfully";
                //     toastr.success(successMessage);
                // }
            }
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_ATTENDENT_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}


export const UpdateAttendentListData = (examId, pageNumber, rowPerPage, requestBody) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(GETATTENDENTLISTDATA + `/${examId}` + `/${pageNumber}` + `/${rowPerPage}`, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response) {
                dispatch({
                    type: UPDATE_ATTENDENT_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: UPDATE_ATTENDENT_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

                if (requestBody.length > 0) {
                    let successMessage = "Data Updated successfully";
                    toastr.success(successMessage);
                }
            }
        } catch (error) {
            dispatch({
                type: UPDATE_ATTENDENT_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getVenueDashboardCount = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETVENUEDASHBOARDCOUNT, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_VENUE_DASHBOARD_COUNT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getAllExamsListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if (searchText != '') {
                response = await API.get(GETALLEXAMLISTDATA + `/${pageNumber}` + `/${rowPerPage}` + `?examname=${searchText}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GETALLEXAMLISTDATA + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

            }

            if (response) {

                dispatch({
                    type: SET_EXAM_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch({
                    type: SET_ALL_EXAM_LIST,
                    payload: response.data,
                });
                if(response.data && response.data.examList && response.data.examList.length === 0){
                    toastr.error("No Data Found");
                }
            }
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_DOCUMENT_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }

}

export const getAllDocumentListPagination = (pageNumber, rowPerPage, advtId, venueId, year, examcenterid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if (!advtId && venueId) {
               
                response = await API.get(GETDOCUMENTLISTDATA + `/${pageNumber}` + `/${rowPerPage}` + `?venueid=${venueId}` + `&examcenterid=${examcenterid ? examcenterid : ''}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if(advtId&&!venueId){
                response = await API.get(GETDOCUMENTLISTDATA + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${advtId}` + `&examcenterid=${examcenterid ? examcenterid :''}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
             }
             else if(advtId && venueId ){
                response = await API.get(GETDOCUMENTLISTDATA + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${advtId}` + `&venueid=${venueId}` + `&examcenterid=${examcenterid ? examcenterid: ''}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
             }
             else {
                response = await API.get(GETDOCUMENTLISTDATA + `/${pageNumber}` + `/${rowPerPage}` , {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { "year": year}
                });

            }
            

            if (response) {
                dispatch({
                    type: SET_GET_ALL_DOCUMENT_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_DOCUMENT_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });


            }
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_DOCUMENT_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const downloadCircularDoc = (advrtId, docId, documentName) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await axios.request({
                url: DOWNLOADCIRCULARDATA + `?advid=${advrtId}` + `&id=${docId}`,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });
            FileDownload(response.data, `${documentName}.pdf`);
        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getDebarredListPagination = (pageNumber, rowPerPage, searchText) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_All_DEBARRED_PAGINATION + `/${pageNumber}` + `/${rowPerPage}` + `?appno=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }

            else {
                response = await API.get(GET_All_DEBARRED_PAGINATION + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            }
            if (response) {

                dispatch({
                    type: SET_ALL_DEBARRED_DATA,
                    payload: response.data

                });

                dispatch({
                    type: SET_ALL_DEBARRED_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage)
                })
            }

        } catch (error) {
            dispatch({
                type: SET_ALL_DEBARRED_DATA,
                payload: {}
            })
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getCollectorDebarredListPagination = (pageNumber, rowPerPage, searchText, venueId,) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if (!searchText && venueId)  {
                response = await API.get(GET_All_DEBARRED_PAGINATION + `/${pageNumber}` + `/${rowPerPage}`+`?venueid=${venueId}`,{
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
            else if(searchText && !venueId){
                response = await API.get(GET_All_DEBARRED_PAGINATION + `/${pageNumber}` + `/${rowPerPage}` + `?appno=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            }else if(searchText && venueId){
                response = await API.get(GET_All_DEBARRED_PAGINATION + `/${pageNumber}` + `/${rowPerPage}` + `?appno=${searchText.trim()}&venueid=${venueId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            }else{
                response = await API.get(GET_All_DEBARRED_PAGINATION + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            }
            if (response) {

                dispatch({
                    type: SET_ALL_DEBARRED_DATA,
                    payload: response.data

                });

                dispatch({
                    type: SET_ALL_DEBARRED_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage)
                })
            }

        } catch (error) {
            dispatch({
                type: SET_ALL_DEBARRED_DATA,
                payload: {}
            })
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}



export const getDebrredData = (id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_DEBARRED_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            dispatch({
                type: SET_DEBARRED_DATA,
                payload: response.data
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    }
}


export const resetDebarredList = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_ALL_DEBARRED_DATA,
            payload: {}
        });
    }
}

export const resetDebarred = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_DEBARRED_DATA,
            payload: {}
        })
    }
}

export const addDebarredData = (data, setAddDebarredList) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();
        if (data.applicationId) {
            formData.append('applicationId', data.applicationId);
        }
        if (data.evidence) {
            formData.append('evidence', data.evidence[0])
        }
        if (data.remarks) {
            formData.append('remarks', data.remarks);
        }

        if (data.fromDate) {
            formData.append('fromDate', moment(data.fromDate, 'YYYY-MM-DDTHH:mm:ss'));
        }
        if (data.toDate) {
            formData.append('toDate', moment(data.toDate, 'YYYY-MM-DDTHH:mm:ss'));
        }

        if (data.reportingBy) {
            formData.append('reportingBy', data.reportingBy);
        }
        if (data.oasUser) {
            formData.append('oasUser', data.oasUser);
        }
        if (data.oasRemarks) {
            formData.append('oasRemarks', data.oasRemarks);
        }
        if (data.isActive) {
            formData.append('isActive', data.isActive)
        }

        let response;

        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",

        }
        try {
            response = await API.post(ADD_NEW_DEBARRED, formData, { headers: header, });

            dispatch(resetDebarred());
            dispatch(resetDebarredList());
            setAddDebarredList({ "Mode": false });
            dispatch(getDebarredListPagination(0, 10));


            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    }
}


export const editDebarredData = (data, setAddDebarredList) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();
        data.applicationId = parseInt(data.applicationId)
        if (data.id) {
            formData.append('id', data.id)
        }
        if (data.applicationId) {
            formData.append('applicationId', parseInt(data.applicationId));
        }

        if (data.evidence.length > 0) {
            formData.append('evidence', data.evidence[0])
        }
        if (data.remarks) {
            formData.append('remarks', data.remarks);
        }

        if (data.fromDate) {
            formData.append('fromDate', moment(data.fromDate, 'YYYY-MM-DDTHH:mm:ss'));
        }
        if (data.toDate) {
            formData.append('toDate', moment(data.toDate, 'YYYY-MM-DDTHH:mm:ss'));
        }

        if (data.reportingBy) {
            formData.append('reportingBy', data.reportingBy);
        }
        if (data.oasUser) {
            formData.append('oasUser', data.oasUser);
        }
        if (data.oasRemarks) {
            formData.append('oasRemarks', data.oasRemarks);
        }
        if (data.isActive) {
            formData.append('isActive', data.isActive)
        }
        let response;
        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",

        }
        try {
            response = await API.patch(UPDATE_DEBARRED, formData, {
                headers: header
            });
            dispatch(resetDebarred());
            dispatch(resetDebarredList());
            setAddDebarredList({ "Mode": false });
            dispatch(getDebarredListPagination(0, 10));

            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }

}
export const manageDebarredData = (requestBody, rowPerPage, listCurrentPage, textToSearch) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",
        }
        try {
            response = await API.patch(DELETE_DEBARRED_DATA, requestBody, { headers: header })
            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }
            dispatch(getDebarredListPagination(showPage, rowPerPage, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getAllVenueList = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VENUE_LIST, { headers: { Authorization: `Bearer ${token}` } });
            dispatch({
                type: SET_ALL_VENUES_LIST,
                payload: response.data
            })

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const debarredTypeDropDown = () => {
    return async function (dispatch) {

        try {
            let response = await API.get(GET_DEBARRED_DROPDOWN + `?module=mpsc` + `&type=debarred`);
            if (response && response.data) {
                dispatch({
                    type: SET_ALL_DEBARRED_DROPDOWN,
                    payload: response.data
                })
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const roleList = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETROLES, { headers: { Authorization: `Bearer ${token}` } });
            dispatch({
                type: GET_ALL_ROLES,
                payload: response.data
            })
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const getDebarredFileData = (applicationId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.get(GET_EVIDENCE_DATA + `/${applicationId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            dispatch({

                payload: response.data,
                type: SET_EVIDENCE_DATA
            })

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }

}

export const collectorVenueDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_COLLECTOR_VENUES, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: GET_ALL_COLLECTOR_VENUE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const collectorAttendancePagination = (venueId, examId, pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ATTENDANCE_PAGINATION_VENUE + `/${venueId}` + `/${examId}` + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            dispatch({
                type: GET_COLLECTOR_ATTENDANCE_LIST,
                payload: response.data
            });
            dispatch({
                type: SET_COLLECTOR_ATTENDANCE_LIST,
                payload: (pageNumber * rowPerPage)
            })
        } catch (error) {
            dispatch({
                type: GET_COLLECTOR_ATTENDANCE_LIST,
                payload: {}
            })
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const updateAttendentListCollector = (venueId, examId, pageNumber, rowPerPage, requestBody) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(GET_ATTENDANCE_PAGINATION_VENUE + `/${venueId}` + `/${examId}` + `/${pageNumber}` + `/${rowPerPage}`, requestBody, {
                headers: { Authorization: `Bearer ${token}` }
            })

            if (response) {
                dispatch({
                    type: UPDATE_ATTENDENT_LIST_COLLECTOR,
                    payload: response.data,
                });
                dispatch({
                    type: UPDATE_ATTENDENT_LIST_COLLECTOR_PAGINATION,
                    payload: (pageNumber * rowPerPage),
                });

                if (requestBody.length > 0) {
                    let successMessage = "Data Updated successfully";
                    toastr.success(successMessage);
                }
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const advertisementExamList = (venueid, pageNumber, rowPerPage, searchText) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if (!searchText) {
                response = await API.get(GET_EXAMLIST_PAGINATION_VENUE + `/${venueid}` + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GET_EXAMLIST_PAGINATION_VENUE + `/${venueid}` + `/${pageNumber}` + `/${rowPerPage}` + `?examname=${searchText}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {

                dispatch({
                    type: SET_EXAM_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch({
                    type: SET_ALL_EXAM_LIST,
                    payload: response.data,
                });

                if (response.data && response.data.examList.length === 0) {
                    toastr.error("No data found")
                }
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }

}

export const getCollectorsUserListData = (venueId, pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_USERLIST_PAGINATION_VENUE + `/${venueId}` + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response) {
                dispatch({
                    type: SET_GET_ALL_COLLECTOR_USER_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_USERS_LIST_PAGE_NO_COUNTER_COLLECTOR,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_COLLECTOR_USER_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getCollectorDashboardCount = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VENUECOLLECTOR_COUNT, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_COLLECTOR_DASHBOARD_COUNT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getVenueAdvertisementListAPI = (pageNumber, rowPerPage, year, examcenterid, advertisementtype, examsubjectid, examdate) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VENUE_ADVERTISEMENT_LIST + `/${pageNumber}` + `/${rowPerPage}` + `?year=${year}` + `&examcenterid=${examcenterid}` + `&advertisementtype=${advertisementtype}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examdate}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if(response){
                dispatch({
                    type: SET_VENUE_ADVERTISEMENT_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_VENUE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getNonAssignedVenueAdvertisementListAPI = (pageNumber, rowPerPage, year, examcenterid, advertisementtype, examsubjectid, examdate) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST + `/${pageNumber}` + `/${rowPerPage}` + `?year=${year}` + `&examcenterid=${examcenterid}` + `&advertisementtype=${advertisementtype}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examdate}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if(response){
                dispatch({
                    type: SET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
 
    };
}